const layoutButtons = document.querySelectorAll('.layout-button');

layoutButtons.forEach((layoutButton) => {
  const mainButton = layoutButton.querySelector('.layout-button__btn');
  const items = [...layoutButton.querySelectorAll('.layout-button__list-item')];

  if (!mainButton || !items.length) return;

  const updateItemDimensions = () => {
    const { width: mainWidth } = mainButton.getBoundingClientRect();
    layoutButton.style.setProperty('--main-button-width', `${mainWidth}px`);

    items.forEach((item, index) => {
      const { width, height } = item.getBoundingClientRect();

      layoutButton.style.setProperty(`--item-${index + 1}-width`, `${width}px`);

      layoutButton.style.setProperty(`--item-${index + 1}-height`, `${height}px`);
    });
  };

  // Initial calculation
  requestAnimationFrame(updateItemDimensions);

  // Recalculate on resize
  window.addEventListener('resize', updateItemDimensions);

  // Recalculate if item dimensions change
  const resizeObserver = new ResizeObserver(updateItemDimensions);

  resizeObserver.observe(mainButton);

  items.forEach((item) => {
    resizeObserver.observe(item);
  });
});
